define.alias("ember-math-helpers/helpers/sqrt", "calendar/helpers/sqrt");